module.exports = __webpack_public_path__ + "static/media/thumbnail-apartamentos.b2ff1b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/thumbnail-apartamentos.png
// module id = 399
// module chunks = 0